import { tss } from 'tss-react/mui';

const useStyles = tss
  .withParams<{
    deviceDetailsCollapsed: boolean;
  }>()
  .create(({ theme, deviceDetailsCollapsed }) => ({
    tab: {
      color: theme.vars.palette.text.secondary,
      [theme.breakpoints.down('md')]: {
        fontSize: '0.75rem',
        minWidth: '3rem'
      }
    },
    devicesPage: {
      display: 'flex',
      flexDirection: 'column',
      height: '100%'
    },
    headerFunctionStrip: {
      backgroundColor: theme.vars.palette.transparent.a5,
      borderRadius: '.25rem',
      padding: '.8rem'
    },
    devicesPageContent: {
      display: 'grid',
      flex: 1,
      height: '100%',
      gap: '1.5rem',
      gridTemplateColumns: deviceDetailsCollapsed
        ? 'auto'
        : 'auto minmax(21.875rem, 20vw)',
      [theme.breakpoints.down('xl')]: {
        gridAutoFlow: 'row',
        gridTemplateRows: 'auto auto auto',
        '&:after': {
          height: '0.5rem',
          content: '""'
        }
      },
      [theme.breakpoints.down('md')]: {
        gridTemplateColumns: 'auto',
        gridTemplateRows: deviceDetailsCollapsed ? 'auto' : 'repeat(5, auto)'
      }
    },
    btnIcoHide: {
      marginRight: '0rem'
    },
    searchbarActionBtnGroup: {
      '& .btnHide': {
        display: 'none'
      },
      [theme.breakpoints.down('xxl')]: {
        position: 'unset'
      },
      [theme.breakpoints.down('xl')]: {
        position: 'unset'
      },
      [theme.breakpoints.down('lg')]: {}
    },
    floatInlineEnd: {
      float: 'inline-end',
      '& .MuiButton-startIcon': {
        marginRight: '0rem'
      }
    },
    resizablePanelHeighFix: {
      height: '100%',
      [theme.breakpoints.up('xl')]: {
        height: '100%'
      },
      '@media (max-height: 732px)': {
        height: '100vh'
      }
    },
    hideLabelBreckpoint: {
      [theme.breakpoints.down('xxl')]: {
        display: 'flex'
      },
      display: 'none'
    }
  }));

export default useStyles;
